<template>
  <svg
    class="icon icon-sm"
    :class="{ open: isOpen }"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Menu</title>
    <rect class="line1" y="4" width="32" height="5"></rect>
    <rect class="line2" y="13.5" width="32" height="5"></rect>
    <rect class="line3" y="13.5" width="32" height="5"></rect>
    <rect class="line4" y="23" width="32" height="5"></rect>
  </svg>
</template>

<script lang="ts" setup>
defineProps<{ isOpen: boolean }>()
</script>

<style scoped>
rect {
  transition:
    transform 0.5s,
    opacity 0.1s 0.25s;
  @apply opacity-100 origin-center rotate-0 translate-y-0 ease-in-out;
}

.open .line1 {
  @apply opacity-0 translate-y-1/3;
}

.open .line2 {
  @apply rotate-45 delay-200;
}

.open .line3 {
  @apply -rotate-45 delay-200;
}

.open .line4 {
  @apply opacity-0 -translate-y-1/3;
}
</style>
